import React, { Component } from "react";
import { connect } from "react-redux";
//import { Link } from "react-router-dom";
import moment from "moment";
import { Parse } from "parse";
import Header from "../Header/header";
import HeaderContainer from "../Header/LandingHeader/HeaderContainer"
import Footer from "../Footer/footer";
import NewMessageForm from "./NewMessageForm";
import ModalCorrespondents from "./modalCorrespondents";
import { getChatAvatar, getLargeAvatar } from "../Constants/functions";
import { dispatchUser } from "../Actions/user.actions";
import { Contentstyled, ColShadow, Layoutstyled } from "../Constants/style";
import { Button, message, Row, Col, List, Divider } from "antd";
Parse.initialize("6cev9RMB5Q36eXubFhT27zEzDJ9ZfCDDBJv87csPPYE62tAvKD");

class Chat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      correspondents: "",
      lastMessages: "",
      allMessages: "",
      toId: null,
      correspondent: null,
      loading: true,
      hasMore: false
    };
    this.deleteMessage = this.deleteMessage.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  async componentDidMount() {
    try {
      this.currentUser = await Parse.User.current().fetch();
      if (this.currentUser === null || this.currentUser === undefined) {
        this.props.userDisconnected();
        this.setState({ redirectToHomePage: true });
        return message.warn("Ta session a expiré, reconnecte-toi !");
      }
      this.props.dispatchUser(this.currentUser);
      if (Parse.User.current().attributes.team !== undefined) {
        var ctx = this;
        Parse.Cloud.run("getChat").then(function(conv) {
          var json2 = JSON.stringify(conv);
          var jsonCorrespondants = JSON.parse(json2);
          ctx.setState({ correspondents: jsonCorrespondants });
        });
      }
      this.setState({ loading: false });
    } catch (error) {
      console.log("error : ", error);
      if (error.code === 209 || error.message === "invalid session token") {
        console.log("invalid session token");
        this.props.userDisconnected();
        this.setState({ redirectToHomePage: true });
        return message.warn("Ta session a expiré, reconnecte-toi !");
      }
    }
  }

  getMessages = id => {
    var ctx = this;
    Parse.Cloud.run("getMessages", {
      correspondentId: id
    }).then(function(messages) {
      var json2 = JSON.stringify(messages);
      var jsonConversations = JSON.parse(json2);
      var lastMessages = jsonConversations.slice(
        Math.max(jsonConversations.length - 10, 0)
      );
      ctx.setState({ allMessages: jsonConversations });
      ctx.setState({ lastMessages: lastMessages });
      ctx.setState({ toId: id });
    });
  };

  ChooseIfsendmessage = conversations => {
    if (conversations !== "") {
      return (
        <NewMessageForm to={this.state.toId} getMessages={this.getMessages} />
      );
    }
  };

  onClick = item => {
    var ctx = this;
    Parse.Cloud.run("getMessages", {
      correspondentId: item.objectId
    }).then(function(messages) {
      var json2 = JSON.stringify(messages);
      var jsonConversations = JSON.parse(json2);
      var lastMessages = jsonConversations.slice(
        Math.max(jsonConversations.length - 10, 0)
      );
      ctx.setState({ allMessages: jsonConversations });
      ctx.setState({ lastMessages: lastMessages });
      ctx.setState({ toId: item.objectId });
      ctx.setState({ correspondent: item });
    });
  };

  deleteMessage = chatMessage => {
    var ctx = this;
    var query = new Parse.Query("Message");

    // query to get the message Object and delete it
    query.get(chatMessage.objectId).then(function(messageToDelete) {
      messageToDelete.destroy();
      message.warn("Message effacé");
      Parse.Cloud.run("getMessages", {
        correspondentId: chatMessage.to.objectId
      }).then(function(messages) {
        var json2 = JSON.stringify(messages);
        var jsonConversations = JSON.parse(json2);
        var lastMessages = jsonConversations.slice(
          Math.max(jsonConversations.length - 10, 0)
        );
        ctx.setState({ lastMessages: lastMessages });
        ctx.setState({ allMessages: jsonConversations });
      });
    });
  };

  chooseChatHeader() {
    return this.state.correspondent !== null ? (
      <h3>
        {" "}
        {getChatAvatar(this.state.correspondent)}
        {this.state.correspondent.nickName}
      </h3>
    ) : (
      <h3> Chat </h3>
    );
  }

  chooseLoadMoreButton = lastMessages => {
    if (
      lastMessages !== "" &&
      this.state.allMessages.length > lastMessages.length
    ) {
      return (
        <Button
          style={{
            fontSize: "14px",
            color: "#fff",
            backgroundColor: "#0000FE",
            borderColor: "#0000FE"
          }}
          onClick={() => this.loadMoreMessages()}
        >
          {" "}
          Charger plus de messages{" "}
        </Button>
      );
    }
  };

  loadMoreMessages() {
    var length = this.state.lastMessages.length;
    var lastMessages = this.state.allMessages.slice(
      Math.max(this.state.allMessages.length - (10 + length), 0)
    );
    this.setState({ lastMessages: lastMessages });
    message.success("Messages actualisés !");
  }

  styleMessage = message => {
    var user = Parse.User.current();

    if (message.from.objectId === user.id) {
      return (
        <div
          style={{
            width: "100%",
            color: "black",
            left: "0",
            height: "100%",
            background: ""
          }}
        >
          <div
            style={{
              width: "40%",
              left: "50%",
              position: "relative",
              background: "#94C7D1",
              borderRadius: "2vh",
              paddingTop: "1vh",
              paddingBottom: "1vh"
            }}
          >
            <div
              style={{
                marginLeft: "2vh"
              }}
            >
              {getChatAvatar(message.from)}
              {message.text}
              <p
                style={{
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginTop: "8px"
                }}
              >
                Envoyé le {moment(message.createdAt).format("LL")} à{" "}
                {moment(message.createdAt).format("LT")}
                <span
                  style={{
                    marginTop: "5px",
                    marginLeft: "10px",
                    color: "#FFF",
                    cursor: "pointer"
                  }}
                  onClick={() => this.deleteMessage(message)}
                >
                  Supprimer mon message
                </span>
              </p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        style={{
          width: "100%",
          color: "black",
          left: "0",
          height: "100%"
        }}
      >
        <div
          style={{
            width: "40%",
            position: "relative",
            background: "#ffe897",
            borderRadius: "2vh",
            paddingTop: "1vh",
            paddingBottom: "1vh",
            left: "7%"
          }}
        >
          <div
            style={{
              marginLeft: "2vh"
            }}
          >
            {getChatAvatar(message.from)}
            {message.text}
            <p
              style={{
                fontSize: "10px",
                fontStyle: "italic",
                marginTop: "5px",
                marginLeft: "10px"
              }}
            >
              Envoyé le {moment(message.createdAt).format("LL")} à{" "}
              {moment(message.createdAt).format("LT")}
            </p>
          </div>
        </div>
      </div>
    );
  };

  render() {
    var currentUser = Parse.User.current();
    if (currentUser.attributes.team === undefined) {
      return (
        <Layoutstyled>
          <Header />
          <HeaderContainer />
          <Contentstyled>
            <h4 style={{ textAlign: "center", marginTop: "15%" }}>
              {`Vous n'êtes pas encore dans une Team ! Veuillez attendre qu'un administrateur vous en attribue une. `}
            </h4>
          </Contentstyled>
          <Footer />
        </Layoutstyled>
      );
    }
    const { correspondents, lastMessages } = this.state;
    return (
      <Layoutstyled>
        <Header />
        <HeaderContainer />
        <Contentstyled>
          <Row type="flex">
            <ColShadow
              style={{
                background: "#fff",
                padding: 24,
                radius: 4
              }}
              xs={24}
              lg={6}
              xl={5}
            >
              <Col justify="center">
                <Row
                  style={{ fontWeight: 700, paddingTop: "1vh" }}
                  type="flex"
                  justify="center"
                >
                  <h4> {`Mes conversations`} </h4>
                </Row>
                <Row type="flex" justify="center" style={{ paddingTop: "2vh" }}>
                  <ModalCorrespondents onClick={this.onClick} />
                </Row>
                <Divider />

                <Row type="flex" justify="center">
                  <List
                    size="large"
                    itemLayout="horizontal"
                    dataSource={correspondents}
                    split={false}
                    locale={{
                      emptyText: "Vous n'avez pas reçu ou envoyé de message."
                    }}
                    display="flex"
                    pagination={{
                      pageSize: 10,
                      hideOnSinglePage: true
                    }}
                    renderItem={item => (
                      <List.Item
                        onClick={() => this.onClick(item)}
                        key={item.id}
                      >
                        <List.Item.Meta
                          avatar={getLargeAvatar(item)}
                          title={item.nickName}
                        />
                      </List.Item>
                    )}
                  />
                </Row>
              </Col>
            </ColShadow>

            <ColShadow
              style={{ background: "#fff", padding: 24, radius: 10 }}
              xs={24}
              lg={{ span: 17, offset: 1 }}
              xl={{ span: 17, offset: 1 }}
            >
              <div> {this.chooseChatHeader()} </div>

              <Divider className="short" />
              <div>
                <Row
                  justify="center"
                  type="flex"
                  style={{ paddingBottom: "2vh" }}
                >
                  {" "}
                  {this.chooseLoadMoreButton(lastMessages)}
                </Row>
                <List
                  itemLayout="horizontal"
                  dataSource={lastMessages}
                  split={false}
                  locale={{
                    emptyText: "Vous n'avez pas reçu ou envoyé de message"
                  }}
                  display="flex"
                  renderItem={item => (
                    <List.Item>
                      <Col type="flex" style={{ width: "100%" }}>
                        <Row type="flex">{this.styleMessage(item)}</Row>
                      </Col>
                    </List.Item>
                  )}
                />
              </div>
              <Row style={{ paddingTop: "4vh" }}>
                {" "}
                {this.ChooseIfsendmessage(lastMessages)}{" "}
              </Row>
            </ColShadow>
          </Row>
        </Contentstyled>
        <Footer />
      </Layoutstyled>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;
const mapDispatchToProps = dispatch => {
  return {
    userDisconnected() {
      Parse.User.logOut();
      dispatch({ type: "disconnect" });
    },
    dispatchUser(user){
      dispatch(dispatchUser(user))
    }
  };
};

const connectedChat = connect(
  mapStateToProps,
  mapDispatchToProps
)(Chat);
export default connectedChat;
